import React, { useEffect, useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import useMobileDetect from 'helpers/mobile-detect'

import styles from './about-podcast.module.scss'

export default function AboutPodCast (props) {
  const currentDevice = useMobileDetect()
  const [imageUrl, setImageUrl] = useState('/static/images/about/bg-podcast.png')

  useEffect(() => {
    if (currentDevice.isMobile() && currentDevice.width < 768) {
      setImageUrl('/static/images/about/bg-m-podcast.png')
    } else {
      setImageUrl('/static/images/about/bg-podcast.png')
    }
  }, [currentDevice.width])

  return (
    <section className={styles['about-podcast']}>
      <img className={styles['about-podcast__img-podcast'] + ' img-fluid'} src={imageUrl} alt={'Podcast'} />
      <div className='container'>
        <Row>
          <Col xs={12} md={6} className={styles['about-podcast__content']}>
            <h3>LISTEN TO mike’s podcast</h3>
            <p>
            "Mike motivates and educates his audience on topics ranging from post-pregnancy weight loss to double bodyweight bench presses. He also answers your questions and brings you behind the scenes of his world-class training camps."
            </p>
          </Col>
          <Col xs={12} md={6} className={styles['about-podcast__poscast-spotify'] + ' p-0'}>
            <iframe
              title={'Dolce Diet Podcast'}
              src='https://open.spotify.com/embed-podcast/show/1AGtr9moftDUzK8qN4vnbU'
              width='100%'
              height='160px'
              frameBorder='0'
              allowtransparency='true'
              allow='encrypted-media'
            ></iframe>
            <div className={styles['about-podcast__list-social']}>
              <p>Listen on: </p>
              <a href='https://podcasts.apple.com/us/podcast/the-mike-dolce-show/id591709101' target="__blank" className={styles['about-podcast__itune']}>
                <img src='/static/images/about/apple.svg' alt={'Apple'} /> iTunes
              </a>
              <a
                href='https://open.spotify.com/show/1AGtr9moftDUzK8qN4vnbU?si=kxHv57RQRmiPA_zJTFQ_Bw'
                target='__blank'
              >
                <img src='/static/images/about/spotify.svg' alt={'Spotify'} /> Spotify
              </a>
              <a href='https://www.youtube.com/user/DolceDiet' target='__blank'>
                <img src='/static/images/about/icon-youtube.svg' alt={'youtube'} /> Youtube
              </a>
              <a
                href='https://www.stitcher.com/show/the-mike-dolce-show'
                target='__blank'
              >
                <img src='/static/images/about/stitcher.svg' alt={'STITCHER'} style={{width: 21}} className={'me-1'} />
                STITCHER
              </a>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  )
}
